import { assetThumbnailUrl } from '@/views/volc-asset/assetMedia'

// Display only: never assign this result to records, versions or references.
export const imageThumbnailUrl = source => assetThumbnailUrl(source)

// Retry only the thumbnail for this source. An original failure stops here,
// and a stale event cannot replace an image belonging to another record.
export function handleImageThumbnailError(event, source) {
  const image = event?.target
  const thumbnail = imageThumbnailUrl(source)
  if (!source || thumbnail === source || image?.getAttribute('src') !== thumbnail) return false
  image.setAttribute('src', source)
  return true
}
